<section>
    <main *ngIf="this.trans" class="grid p-fluid col-12 lg:col-10">
        <!-- Información del Ciudadano -->
        <div class="col-12 md:col-4">
            <div>
                <b>{{ trans.tipoPersona }}:</b>
            </div>
            <div>
                <p *ngIf="isLoading; else tipoPersona">
                    <p-skeleton width="10rem"></p-skeleton>
                </p>
                <ng-template #tipoPersona>
                    <p>{{ ciudadanosInfo.tipoPersona }}</p>
                </ng-template>
            </div>
        </div>
        @if (ciudadanosInfo) {            
            <!-- Switch para mostrar campos según el tipo de persona -->
            <ng-container [ngSwitch]="ciudadanosInfo.tipoPersona">
                
                <!-- Anónimo: solo país y correo -->
                <ng-container *ngSwitchCase="'Anónimo'">
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.pais }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else pais">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #pais>
                                <p>{{ ciudadanosInfo.pais }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.correo }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else correo">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #correo>
                                <p>{{ ciudadanosInfo.correo }}</p>
                            </ng-template>
                        </div>
                    </div>
                </ng-container>
                
                <!-- Jurídica -->
                <ng-container *ngSwitchCase="'Jurídica'">
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.tipoIdentificacion }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else tipoIdentificacion">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #tipoIdentificacion>
                                <p>{{ ciudadanosInfo.tiposIdentificacion }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.identificacion }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else identificacion">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #identificacion>
                                <p>{{ ciudadanosInfo.identificacion }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.razonSocial }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else razonSocial">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #razonSocial>
                                <p>{{ ciudadanosInfo.razonSocial }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.pais }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else pais">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #pais>
                                <p>{{ ciudadanosInfo.pais }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.departamento }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else departamento">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #departamento>
                                <p>{{ ciudadanosInfo.departamento }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.municipio }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else municipios">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #municipios>
                                <p>{{ ciudadanosInfo.municipios }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4" *ngIf="ciudadanosInfo?.tipoPoblacion">
                        <div>
                            <b>{{ trans.tipoPoblacion }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else tipoPoblacion">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #tipoPoblacion>
                                <p>{{ ciudadanosInfo.tipoPoblacion }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.direccion }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else direccion">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #direccion>
                                <p>{{ ciudadanosInfo.direccion }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.telefono }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else telefono">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #telefono>
                                <p>{{ ciudadanosInfo.telefono }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.presentaDiscapacidad }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else presentaDiscapacidad">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #presentaDiscapacidad>
                                <p>{{ ciudadanosInfo.tipoDiscapacidad ? 'Sí' : 'No' }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4" *ngIf="ciudadanosInfo?.tipoDiscapacidad">
                        <div>
                            <b>{{ trans.discapacidad }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else tipoDiscapacidad">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #tipoDiscapacidad>
                                <p>{{ ciudadanosInfo.tipoDiscapacidad }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.correo }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else correo">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #correo>
                                <p>{{ ciudadanosInfo.correo }}</p>
                            </ng-template>
                        </div>
                    </div>
                </ng-container>
                
                <!-- Natural -->
                <ng-container *ngSwitchCase="'Natural'">
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.tipoIdentificacion }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else tipoIdentificacion">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #tipoIdentificacion>
                                <p>{{ ciudadanosInfo.tiposIdentificacion }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.identificacion }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else identificacion">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #identificacion>
                                <p>{{ ciudadanosInfo.identificacion }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.nombre }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else nombre">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #nombre>
                                <p>{{ ciudadanosInfo.nombreCompleto }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.pais }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else pais">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #pais>
                                <p>{{ ciudadanosInfo.pais }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.departamento }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else departamento">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #departamento>
                                <p>{{ ciudadanosInfo.departamento }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.municipio }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else municipios">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #municipios>
                                <p>{{ ciudadanosInfo.municipios }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4" *ngIf="ciudadanosInfo?.tipoPoblacion">
                        <div>
                            <b>{{ trans.tipoPoblacion }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else tipoPoblacion">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #tipoPoblacion>
                                <p>{{ ciudadanosInfo.tipoPoblacion }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.direccion }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else direccion">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #direccion>
                                <p>{{ ciudadanosInfo.direccion }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.telefono }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else telefono">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #telefono>
                                <p>{{ ciudadanosInfo.telefono }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.presentaDiscapacidad }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else presentaDiscapacidad">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #presentaDiscapacidad>
                                <p>{{ ciudadanosInfo.tipoDiscapacidad ? 'Sí' : 'No' }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4" *ngIf="ciudadanosInfo?.tipoDiscapacidad">
                        <div>
                            <b>{{ trans.discapacidad }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else tipoDiscapacidad">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #tipoDiscapacidad>
                                <p>{{ ciudadanosInfo.tipoDiscapacidad }}</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div>
                            <b>{{ trans.correo }}:</b>
                        </div>
                        <div>
                            <p *ngIf="isLoading; else correo">
                                <p-skeleton width="10rem"></p-skeleton>
                            </p>
                            <ng-template #correo>
                                <p>{{ ciudadanosInfo.correo }}</p>
                            </ng-template>
                        </div>
                    </div>
                </ng-container>
                
                <!-- Default case -->
                <ng-container *ngSwitchDefault>
                    <div class="col-12">
                        <p>No hay información disponible para este tipo de persona.</p>
                    </div>
                </ng-container>
            </ng-container>
        }
        
    </main>
</section>